
import { useState, useEffect } from 'react';
import { getPerformanceMetrics, initializePerformanceMonitoring } from '@/utils/performanceMonitor';

export const usePerformanceMonitoring = (isVisible: boolean) => {
  const [metrics, setMetrics] = useState(getPerformanceMetrics());

  useEffect(() => {
    // Initialize performance monitoring
    const monitor = initializePerformanceMonitoring();

    // Only proceed if component is visible
    if (!isVisible) return;

    // Update metrics after page load and periodically after that
    const updateMetrics = () => {
      setMetrics(monitor.getMetrics());
    };

    // Initial metrics collection
    setTimeout(updateMetrics, 500);
    
    // Set up periodic updates while the panel is visible
    const updateInterval = setInterval(updateMetrics, 5000);

    // Listen for client-side navigation events
    const handleRouteChange = () => {
      // Update metrics after navigation
      setTimeout(updateMetrics, 1000);
    };

    // Use a MutationObserver to detect DOM changes as a proxy for route changes in SPAs
    const observer = new MutationObserver((mutations) => {
      const significantChanges = mutations.some(mutation => 
        mutation.addedNodes.length > 5 || 
        mutation.removedNodes.length > 5);
      
      if (significantChanges) {
        handleRouteChange();
      }
    });
    
    // Start observing the document body for significant DOM changes
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearInterval(updateInterval);
      observer.disconnect();
    };
  }, [isVisible]);

  const refreshMetrics = () => {
    setMetrics(getPerformanceMetrics());
  };

  return { metrics, refreshMetrics };
};
